import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const CallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <a
      href="tel:0695220018"
      className={`fixed right-4 bottom-4 z-40 transition-all duration-300 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
      }`}
    >
      <Button
        size="lg"
        className="rounded-full h-16 w-16 shadow-lg hover:shadow-xl transition-shadow"
        aria-label="Appeler maintenant"
      >
        <Phone className="h-6 w-6" />
      </Button>
    </a>
  );
};

export default CallButton;
